import React from 'react';
import { Button } from '@/components/ui/button';
import { Play, Pause } from 'lucide-react';

export const PlaybackControls = ({ isPlaying, audioUrl, progress, togglePlay, handleSeek }) => (
  <div className="rounded-2xl p-6 mb-6 border" style={{ backgroundColor: 'rgba(20,20,23,0.8)', borderColor: 'rgba(255,255,255,0.06)' }}>
    <div className="flex items-center justify-center gap-[2px] mb-6 h-12 cursor-pointer" onClick={handleSeek} data-testid="waveform-seek">
      {Array.from({ length: 60 }).map((_, i) => {
        const barProgress = (i / 60) * 100;
        const isPast = barProgress < progress;
        return (
          <div
            key={`bar-${i}`}
            className="w-[3px] rounded-full transition-all duration-150"
            style={{
              height: isPlaying ? `${Math.random() * 36 + 8}px` : `${Math.sin(i * 0.3) * 12 + 16}px`,
              backgroundColor: isPast ? '#6D28D9' : 'rgba(255,255,255,0.1)',
              opacity: isPast ? 1 : 0.4,
            }}
          />
        );
      })}
    </div>

    <div className="flex items-center justify-center gap-6">
      <Button
        onClick={togglePlay}
        disabled={!audioUrl}
        className="w-16 h-16 rounded-full bg-purple-600 hover:bg-purple-500 disabled:opacity-50 shadow-[0_0_30px_rgba(109,40,217,0.4)]"
        data-testid="play-btn"
      >
        {isPlaying ? <Pause className="w-7 h-7" /> : <Play className="w-7 h-7 ml-1" />}
      </Button>
    </div>
  </div>
);
